const apiConstant = {
  loginUser: "login",
  dashboard: "dashboard",
  userCreate: "userCreate",
  updateAdmin: "updateAdmin",
  adminUserList: "getAdminList",
  categoryList: "getCategoryList",
  createCategory: "createCategory",
  addSubCategory: "add-subcategories-to-category",
  updateCategory: "updateCategory",
  deleteCategory: "deleteCategory",
  getCustomerDetail: "getCustomerDetail",
  getCategoryDetail: "getCategoryDetail",
  changeStatusCategory: "updateCategoryStatus",
  productGroupList: "product-group/list",
  productGroupUpdateStatus: "product-group/updateStatus",
  productGroupUpdateFilter: "product-group/update-product-filter-option",
  productGroupCreate: "product-group/create",
  productGroupUpdate: "product-group/update",
  productGroupDetail: "product-group/detail",
  productGroupSinglePriceUpdate: "product/updatePrice",
  productGroupBulkPriceUpdate: "product/bulkUpdatePrice",
  productGroupBulkThreeDUpdate: "product/bulkUpdateThreeDFile",
  productGroupSingleWeightUpdate: "product/updateWeight",
  productGroupSingleQuantityUpdate: "product/updateQuantity",
  productUploadImage: "product-group/update-product-data-object-image",
  inquiryList: "enquiry-list",
  inquiryDetail: "enquiry-details",
  contactInquiryList: "getContactUsInquiryList",
  contactInquiryDetail: "getContactUsInquiryDetail",
  addDeliveryPartner: "delivery-partner/create",
  getDeliveryPartnerList: "delivery-partner/list",
  getDeliveryPartnerDetail: "delivery-partner/detail",
  updateDeliveryPartner: "delivery-partner/update",
  deleteDeliveryPartner: "delivery-partner/delete",
  addSpecialMessage: "special-message/create",
  getSpecialMessageList: "special-message/list",
  getSpecialMessageDetail: "special-message/detail",
  updateSpecialMessage: "special-message/update",
  deleteSpecialMessage: "special-message/delete",
  customerList: "getCustomerList",
  customerDetail: "getCustomerDetail",
  changeStatusCustomer: "customer/updateStatus",
  verifyCustomer: "customer/verify",
  deleteCustomer: "customer/delete",
  downloadCustomerList: "customer/download",
  updateCustomer: "updateCustomer",
  presignedUrl: "get-presigned-url",

  // Front END
  frontLogin: "font-end/login",
  sendLoginOtp: "customer/send-login-otp",
  verifyLoginOtp: "customer/verify-login-otp",
  frontRegister: "font-end/register",
  verifyOTP: "font-end/verifyOTP",
  resendOTP: "font-end/resendOTP",
  frontCategory: "font-end/category",
  frontCategoryDetail: "font-end/category-details",
  frontProductGroup: "font-end/product-group",
  frontProductGroupDetail: "font-end/product-details",
  frontEnquiry: "font-end/submit-enquiry",
  frontProductPriceDiscount: "font-end/get-price-discount",
  frontUpdateEnquiryStatusAndCart: "font-end/update-enquiry-status-and-cart",
  frontContactEnquiry: "font-end/create-inquiry",
  frontCreateSubscriber: "font-end/createSubscriber",
  frontCustomerDetails: "font-end/customer-details",
  frontUpdateCustomerDetails: "font-end/update-customer",
  changePassword: "font-end/change-password",
  frontEndCart: "font-end/cart",
  specialDiscount:"font-end/sendSpecialPriceEmail",
  allProductEmail: "font-end/sendAllProductEmail",
  frontEndCartData: "font-end/cart-data",
  frontEndUpdateCart: "font-end/update-cart",
  frontEndDeleteCart: "font-end/delete-cart",
  createRazorpayOrder: "font-end/create-order",
  verifyRazorpayPayment: "font-end/verify",
  getEnquiryData: "enquiry-data",
};
export default apiConstant
